import { SelectOption } from '@kanda-libs/ks-component-ts';

export const INPUT_PROPS = {
  placeholder: 'Select...',
};

export const COMPLETE_INPUT_PROPS = {
  placeholder: 'Select...',
  name: 'job_completed',
  label: 'Has this job been completed by your tradesperson?',
  options: [
    { name: 'Yes', value: 'Yes' },
    { name: 'No', value: 'No' },
  ],
};

export const COMPLETE_SUPPLY_PROPS = {
  placeholder: 'Select...',
  name: 'job_completed',
  label: 'Has this delivery been completed?',
  options: [
    { name: 'Yes', value: 'Yes' },
    { name: 'No', value: 'No' },
  ],
};

export const COMPLETE_INPUT_INTRO_PROPS = {
  placeholder: 'Select...',
  name: 'job_completed',
  label: 'Has the initial delivery* been made?',
  options: [
    { name: 'Yes', value: 'Yes' },
    { name: 'No', value: 'No' },
  ],
};

export const COMPLETE_INPUT_VALIDATION = {
  required: {
    value: true,
    message: 'You must select an option',
  },
  validate: {
    value: (value) => value === 'Yes',
    message:
      'The work must have been completed before this satisfaction note can be signed',
  },
};

export const INTRO_AVAILABILITY_OPTIONS: SelectOption[] = [
  {
    name: 'I was told by my depot designer',
    value: 'The installer told me when quoting me',
  },
  {
    name: 'I saw it in advertised in the depot',
    value: 'I saw it advertised by the installer',
  },
  {
    name: 'I was told by my tradesperson',
    value: 'I found out when the installer sent me a link via Kanda',
  },
];
export const INTRO_ADVICE_OPTIONS: SelectOption[] = [
  {
    name: 'No',
    value: 'They just sent me a link to apply',
  },
  {
    name: 'Yes, Howdens provided advice',
    value: 'They told me what rates where available',
  },
  {
    name: 'Yes, my tradesperson provided advice',
    value: 'They helped me work out my potential repayments',
  },
  {
    name: 'Yes, Kanda provided advice',
    value: 'They completed the application for me',
  },
];

export const INTRO_PROPS = {
  pressure: {
    label: 'Were you pressured to apply for finance?',
  },
  availability: {
    label: 'How did you first become aware that finance was available?',
    options: INTRO_AVAILABILITY_OPTIONS,
  },
  advice: {
    label:
      'Did you receive any advice during the finance application process about the deposit, interest rate, or loan term?',
    options: INTRO_ADVICE_OPTIONS,
  },
  easiness: {
    label: 'Did you find it hard to apply for finance with Kanda?',
  },
  application: {
    label: 'Who completed your application for finance?',
    options: [
      {
        name: 'I completed the application myself',
        value: 'I completed the application myself',
      },
      {
        name: 'Someone completed the appliation on my behalf',
        value: 'Someone completed the appliation on my behalf',
      },
    ],
  },
};

export const SUPPLY_AVAILABILITY_OPTIONS: SelectOption[] = [
  {
    name: 'The retailer/tradesperson told me when quoting me',
    value: 'The installer told me when quoting me',
  },
  {
    name: 'I saw it advertised by the retailer/tradesperson',
    value: 'I saw it advertised by the installer',
  },
  {
    name: 'I was told by my retailer/tradesperson',
    value: 'I found out when the installer sent me a link via Kanda',
  },
];

export const SUPPLY_PROPS = {
  pressure: {
    label: 'Were you pressured to apply for finance?',
  },
  availability: {
    options: SUPPLY_AVAILABILITY_OPTIONS,
  },
  advice: {
    label:
      'What advice did the retailer/tradesperson give you on your finance application?',
  },
  rate: {
    label:
      'Were you advised to select a specific finance option by the retailer/tradesperson?',
  },
};
